<template>
  <div>
    <countdown
      v-if="leaveTime"
      :leave-time="leaveTime"
      :start-hour="startHour"
      :end-hour="endHour"
      :end-min="endMin"
      :on-countdown-ends="leaveCall"
    />
  </div>
</template>

<script>
  import moment from 'moment';
  import axios from '@axios';
  import Countdown from './Countdown.vue';

  export default {
    components: {
      Countdown,
    },
    props: {
      visit: {
        type: Object,
        required: true,
      },
      prison: {
        type: Object,
        required: true,
      },
      // eslint-disable-next-line vue/require-default-prop
      leaveCall: {
        type: Function,
        required: false,
      },
    },
    data() {
      const endDateTime = moment(this.visit.booked_slot.end_date_time).add(this.prison.hard_close_mins, 'minutes');
      const startDateTime = moment(this.visit.booked_slot.start_date_time);

      return {
        endHour: endDateTime.toDate().getHours().toString(),
        endMin: endDateTime.toDate().getMinutes().toString(),
        startHour: startDateTime.toDate().getHours().toString(),
        startDate: startDateTime.toDate(),
        endDateTime,
        leaveTime: null,
      };
    },
    mounted() {
      this.getStartTime().then(timestamp => {
        this.startDate = moment(timestamp);

        // Get time remaining
        const timeDifference = moment.duration(this.endDateTime.diff(moment(this.startDate)));
        // Get system time and add the difference and store as leaveTime
        // eslint-disable-next-line no-underscore-dangle
        this.leaveTime = moment().add(timeDifference._milliseconds, 'milliseconds');
        // console.log('hours', hoursLeft, 'mins', minutesLeft, 'sec', secondsLeft, 'time', moment(this.leaveTime).toDate());
      });
    },
    methods: {
      async getStartTime() {
        const timestamp = await axios.get(`/api/v1/util/date`);
        return new Date(timestamp.data);
      },
    },
  };
</script>

<style scoped>

</style>
